// frontend/src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#38F2AF", // The bright green from the purchase button
      light: "#5ff7bf",
      dark: "#2bd994",
    },
    secondary: {
      main: "#1A1B25", // Dark background color
      light: "#2A2B35",
      dark: "#15161D",
    },
    background: {
      default: "#13141C", // Darker background
      paper: "#1A1B25", // Sidebar/card background
    },
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1A1B25",
          borderRight: "1px solid rgba(255, 255, 255, 0.05)",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#38F2AF !important",
            color: "#13141C !important",
            "& .MuiListItemIcon-root": {
              color: "#13141C !important",
            },
            "&:hover": {
              backgroundColor: "#2bd994 !important",
            },
          },
          "&:hover": {
            backgroundColor: "rgba(56, 242, 175, 0.08)",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          minWidth: 40,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
          fontSize: "1rem",
        },
        contained: {
          backgroundColor: "#38F2AF",
          color: "#13141C",
          "&:hover": {
            backgroundColor: "#2bd994",
          },
        },
        outlined: {
          borderColor: "#38F2AF",
          color: "#38F2AF",
          "&:hover": {
            borderColor: "#2bd994",
            backgroundColor: "rgba(56, 242, 175, 0.08)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#1A1B25",
          borderRadius: 12,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#1A1B25",
          borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
        },
      },
    },
  },
});

export default theme;
